import React, { useEffect } from 'react';
import RouterBreadcrumbs from '../common/BreadCrumbs';
import { Avatar, Grid } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { fetchManageProductByUUID } from '../../redux/actions/manageProductActions';
import { useParams } from 'react-router-dom';
import ProductDownloadButton from '../Product/ProductDownloadButton';
import ProductInfo from './ProductInfo';
import { lowesImageUrl, productJsonProps } from '../../Constants/Products';
import PCMDataTab from './PCMDataTab.js';
import CustomTabs from '../../components/common/CustomTabs';
import { get } from 'lodash';

// Rendering product name container
const RenderProductName = (product) => {
	if (product) {
		return <span> {get(product, productJsonProps.name)}</span>;
	} else {
		return null;
	}
};

const RenderProductTabs = (product) => {
	const tabs = [
		{
			label: 'PRODUCT DATA',
			component: <PCMDataTab {...product} />,
		},
	];
	return <CustomTabs tabs={tabs} />;
};

const ManageProduct = () => {
	const product = useSelector((s) => s.manageProductDetails);
	const asset = product.linkedAsset;
	const { id } = useParams();
	const dispatch = useDispatch();
	let productImageUrl = '';
	const imgUrl = get(product, productJsonProps.image);
	if (imgUrl) {
		productImageUrl = `${lowesImageUrl}${imgUrl[0].value}`;
	}
	useEffect(() => {
		// fetching Product information by UUID for manage product component on page load.
		dispatch(fetchManageProductByUUID(id));
	}, [dispatch, id]);
	return (
		<Grid container direction="column" spacing={4}>
			<RouterBreadcrumbs />
			<ProductInfo
				avatar={<Avatar variant="square" src={productImageUrl}></Avatar>}
				download={<ProductDownloadButton product={product} />}
				id={id}
				name={<RenderProductName {...product} />}
				asset={asset}
			/>
			<RenderProductTabs {...product} />
		</Grid>
	);
};

export default ManageProduct;
